import React from 'react';

import {render} from 'react-dom';

import {loadSafariAutocompleteFix} from 'app/utils/safari-autocomplete';

import {Chat} from '../chat-app/Chat';

// fix safari autofill/react bug
loadSafariAutocompleteFix();
// never show scrollbar for body, we have scrollable divs
render(<Chat />, document.getElementById('chat-placeholder'));
